import React, { useContext } from 'react';
import Quill from 'quill/core';

const Module = Quill.import('core/module');

export interface PostPreviewControlsOptions {
  scrollToAnchor: (anchor: string) => void;
  postUrl?: string;
}

export const PostPreviewControlsContext =
  React.createContext<PostPreviewControlsOptions | null>(null);

export const usePostPreviewControls = () =>
  useContext(PostPreviewControlsContext);

class PostPreviewControls extends Module<PostPreviewControlsOptions> {
  scrollToAnchor(anchor: string) {
    this.options.scrollToAnchor?.(anchor);
  }

  get postUrl() {
    return this.options.postUrl;
  }
}

export default PostPreviewControls;
